import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/deleteIcon.svg'


const _hoisted_1 = { class: "table-data-root" }
const _hoisted_2 = { class: "bg-white table-card-shell tableCornerRadius" }
const _hoisted_3 = { class: "table-container table-container-fit" }
const _hoisted_4 = { class: "table-header-wrap" }
const _hoisted_5 = { class: "table-header-row" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onMousemove"]
const _hoisted_8 = ["onMousedown"]
const _hoisted_9 = {
  key: 0,
  class: "table-filter-row"
}
const _hoisted_10 = ["onUpdate:modelValue"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "table-body-scroll" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_21 = ["colspan"]
const _hoisted_22 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_23 = { class: "cursor-pointer rowHeight" }
const _hoisted_24 = ["colspan"]
const _hoisted_25 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_28 = {
  key: 1,
  class: "flex justify-center"
}
const _hoisted_29 = {
  key: 2,
  class: "flex justify-center"
}
const _hoisted_30 = {
  key: 3,
  class: "flex justify-center"
}
const _hoisted_31 = { key: 4 }
const _hoisted_32 = ["onMousemove"]
const _hoisted_33 = ["onMousemove"]
const _hoisted_34 = ["onMousemove"]
const _hoisted_35 = ["onMousemove"]
const _hoisted_36 = ["onMousemove"]
const _hoisted_37 = { key: 10 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = ["onMousemove"]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = ["onMousemove"]
const _hoisted_42 = { key: 2 }
const _hoisted_43 = ["onMousemove"]
const _hoisted_44 = { key: 3 }
const _hoisted_45 = ["onMousemove"]
const _hoisted_46 = { key: 11 }
const _hoisted_47 = { class: "flex justify-start items-center h-5" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { key: 12 }
const _hoisted_50 = { key: 13 }
const _hoisted_51 = ["onMousemove"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["table-card-inner", _ctx.pageData!=undefined && _ctx.pageData == 4 ? 'fixHeightTable flex flex-col justify-between':''])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", {
              class: "table-fit-card table-header-table",
              style: _normalizeStyle(_ctx.tableResizeStyle)
            }, [
              _createElementVNode("colgroup", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                  return (_openBlock(), _createElementBlock("col", {
                    key: 'h-'+presentColumn,
                    style: _normalizeStyle(_ctx.columnStyle(presentColumn))
                  }, null, 4))
                }), 128))
              ]),
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                    return (_openBlock(), _createElementBlock("th", {
                      scope: "col",
                      key: presentColumn,
                      class: _normalizeClass(["bg-white capitalize resizable-th", _ctx.getColumnHeadWidth(presentColumn)]),
                      style: _normalizeStyle(_ctx.columnStyle(presentColumn)),
                      onClick: ($event: any) => {_ctx.onHeaderClick(presentColumn); _ctx.doFalse()},
                      onMouseout: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doFalse()))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["flex table-header-label-wrap", _ctx.getPaddingForColumn(presentColumn)])
                      }, [
                        _createElementVNode("div", {
                          class: "table-header-label",
                          onMousemove: ($event: any) => (_ctx.headerToolTip(presentColumn, $event))
                        }, _toDisplayString(_ctx.getColumnLabel(presentColumn)), 41, _hoisted_7),
                        (_ctx.getColumnLabel(presentColumn) != '')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["sort cursor-pointer", _ctx.className == presentColumn ? _ctx.classSort : 'opacity-50'])
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("span", {
                        class: "column-resize-handle",
                        onMousedown: _withModifiers(($event: any) => (_ctx.startColumnResize($event, presentColumn)), ["stop","prevent"])
                      }, null, 40, _hoisted_8)
                    ], 46, _hoisted_6))
                  }), 128))
                ]),
                (_ctx.visibility)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn, index) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: index,
                          class: _normalizeClass(_ctx.getColumnHeadWidth(presentColumn)),
                          style: _normalizeStyle(_ctx.columnStyle(presentColumn))
                        }, [
                          (_ctx.isColumnArrayPresent(presentColumn))
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                class: _normalizeClass(["statusFilter", [_ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect',_ctx.selectInputStyling(presentColumn)]]),
                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event)
                              }, [
                                _createElementVNode("option", {
                                  value: _ctx.filters.presentColumn,
                                  selected: "",
                                  hidden: "",
                                  disabled: ""
                                }, "Select", 8, _hoisted_11),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDropdownOptionsForFilter(presentColumn), (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    class: "optionColors",
                                    key: option.id,
                                    value: option.id
                                  }, _toDisplayString(option.value), 9, _hoisted_12))
                                }), 128))
                              ], 10, _hoisted_10)), [
                                [_vModelSelect, _ctx.filters[presentColumn]]
                              ])
                            : _createCommentVNode("", true),
                          (presentColumn=='Frequency')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 1,
                                class: _normalizeClass(["statusFilter", [_ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect',_ctx.selectInputStyling(presentColumn)]]),
                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event)
                              }, [
                                _createElementVNode("option", {
                                  value: _ctx.filters.presentColumn,
                                  selected: "",
                                  hidden: "",
                                  disabled: ""
                                }, "Select", 8, _hoisted_14),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbFrequency, (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    class: "optionColors",
                                    key: option.value,
                                    value: option.value
                                  }, _toDisplayString(option.key), 9, _hoisted_15))
                                }), 128))
                              ], 10, _hoisted_13)), [
                                [_vModelSelect, _ctx.filters[presentColumn]]
                              ])
                            : (_ctx.isFilterNotNecessary(presentColumn))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                              : _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 3,
                                  type: "text",
                                  class: "searchForInputBoxStyling",
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event),
                                  placeholder: "Search"
                                }, null, 8, _hoisted_17)), [
                                  [
                                    _vModelText,
                                    _ctx.filters[presentColumn],
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                        ], 6))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("table", {
              class: "table-fit-card",
              style: _normalizeStyle(_ctx.tableResizeStyle)
            }, [
              _createElementVNode("colgroup", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                  return (_openBlock(), _createElementBlock("col", {
                    key: 'b-'+presentColumn,
                    style: _normalizeStyle(_ctx.columnStyle(presentColumn))
                  }, null, 4))
                }), 128))
              ]),
              (_ctx.loadData == true)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                    _createElementVNode("tr", _hoisted_20, [
                      _createElementVNode("td", {
                        class: "relative h-5",
                        colspan: _ctx.columnNames.size
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_dots_loader)
                        ])
                      ], 8, _hoisted_21)
                    ])
                  ]))
                : (_ctx.sortedData.length == 0)
                  ? (_openBlock(), _createElementBlock("tbody", {
                      key: 1,
                      class: _normalizeClass(_ctx.pageData!=undefined && _ctx.pageData == 4 ? 'emptyFixed':'')
                    }, [
                      _createElementVNode("tr", _hoisted_23, [
                        _createElementVNode("td", {
                          class: "relative h-10",
                          colspan: _ctx.columnNames.size
                        }, _cache[2] || (_cache[2] = [
                          _createElementVNode("div", { class: "flex justify-center" }, [
                            _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                          ], -1)
                        ]), 8, _hoisted_24)
                      ])
                    ], 2))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (row, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: row,
                          class: "cursor-pointer rowHeight hoverEffectForCompleteRow"
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: presentColumn,
                              onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doFalse())),
                              onClick: ($event: any) => (_ctx.clickedOnActionButton(row, index, presentColumn)),
                              class: _normalizeClass(["cursor-pointer relative", _ctx.getColumnHeadWidth(presentColumn)]),
                              style: _normalizeStyle(_ctx.columnStyle(presentColumn))
                            }, [
                              (_ctx.isColumnPresentForLabel(presentColumn))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.bgColorForStatus(row[presentColumn])])
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(_ctx.textColorForStatus(row[presentColumn]))
                                      }, _toDisplayString(_ctx.getStatusLabelFromColumn(row[presentColumn],presentColumn)), 3)
                                    ], 2)
                                  ]))
                                : (presentColumn == 'statusCode')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["flex items-center justify-center rounded h-5 w-32 px-2 whitespace-nowrap", _ctx.bgColorForFindingStatus(row[presentColumn])])
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(_ctx.textColorForFindingStatus(row[presentColumn]))
                                        }, _toDisplayString(_ctx.getStatusLabelFromColumn(row[presentColumn],presentColumn)), 3)
                                      ], 2)
                                    ]))
                                  : (presentColumn == 'findingStatus')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 whitespace-nowrap", _ctx.bgColorForFindingStatus(row[presentColumn])])
                                        }, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(_ctx.textColorForFindingStatus(row[presentColumn]))
                                          }, _toDisplayString(_ctx.getStatusLabelFromColumn(row[presentColumn],presentColumn)), 3)
                                        ], 2)
                                      ]))
                                    : (presentColumn == 'taskStatus' || presentColumn == 'statusCode')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["flex items-center justify-center rounded h-5 w-32 px-2 whitespace-nowrap", _ctx.colorAuditBg(row[presentColumn])])
                                          }, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(_ctx.colorAuditText(row[presentColumn]))
                                            }, _toDisplayString(_ctx.getStatusLabelFromColumn(row[presentColumn],presentColumn)), 3)
                                          ], 2)
                                        ]))
                                      : (presentColumn=='Frequency')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            _createElementVNode("div", {
                                              class: "table-ellipsis",
                                              onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                            }, _toDisplayString(_ctx.getFrequency(row[presentColumn])), 41, _hoisted_32)
                                          ]))
                                        : (presentColumn == 'findingCategory')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 5,
                                              class: "table-ellipsis text-center",
                                              onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                            }, _toDisplayString(_ctx.getStatusLabelFromColumn(row[presentColumn],presentColumn)), 41, _hoisted_33))
                                          : (presentColumn == 'startDate' || presentColumn == 'endDate'  )
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 6,
                                                class: "table-ellipsis",
                                                onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                              }, _toDisplayString(_ctx.changeDateFormat(row[presentColumn])), 41, _hoisted_34))
                                            : (presentColumn == 'auditPeriod' )
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 7,
                                                  class: _normalizeClass(["table-ellipsis w-36", presentColumn == 'startDate'?'pl-3':'']),
                                                  onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                                }, _toDisplayString(row[presentColumn]), 43, _hoisted_35))
                                              : (presentColumn =='dueDate')
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 8,
                                                    class: _normalizeClass(["flex items-center justify-center w-20 rounded h-5 table-ellipsis mx-auto", _ctx.shouldStyleDueDate(row) ? _ctx.colorForDueDate(row[presentColumn]) : '']),
                                                    onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                                  }, _toDisplayString(row[presentColumn]), 43, _hoisted_36))
                                                : (presentColumn == 'frameWorkControl')
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 9,
                                                      class: _normalizeClass([_ctx.getBorder(), "text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto w-fit flex items-center"])
                                                    }, _toDisplayString(row[presentColumn]), 3))
                                                  : (_ctx.checkuserData(presentColumn))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                        (presentColumn == 'team' )
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                              _createElementVNode("p", {
                                                                class: "cursor-pointer text-xs table-ellipsis",
                                                                onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                                              }, _toDisplayString(row[presentColumn]), 41, _hoisted_39)
                                                            ]))
                                                          : (presentColumn == 'entity')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                                _createElementVNode("p", {
                                                                  class: "cursor-pointer text-xs table-ellipsis",
                                                                  onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                                                }, _toDisplayString(row[presentColumn]), 41, _hoisted_41)
                                                              ]))
                                                            : (presentColumn == 'auditor')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                                  _createElementVNode("div", {
                                                                    class: "cursor-pointer text-xs table-ellipsis",
                                                                    onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                                                  }, _toDisplayString(_ctx.getOwnerName(row[presentColumn])), 41, _hoisted_43)
                                                                ]))
                                                              : (presentColumn == 'assignee')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                                    _createElementVNode("div", {
                                                                      class: "cursor-pointer text-xs table-ellipsis",
                                                                      onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                                                    }, _toDisplayString(row[presentColumn]), 41, _hoisted_45)
                                                                  ]))
                                                                : _createCommentVNode("", true)
                                                      ]))
                                                    : (presentColumn=='deleteIcon')
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                          _createElementVNode("div", _hoisted_47, [
                                                            _createElementVNode("img", {
                                                              src: _imports_0,
                                                              class: "h-5 w-5 cursor-pointer",
                                                              onClick: ($event: any) => (_ctx.clickedOnDeleteButton(row))
                                                            }, null, 8, _hoisted_48)
                                                          ])
                                                        ]))
                                                      : (presentColumn == 'actionButtonAtAudits')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                            _createVNode(_component_Button, {
                                                              type: "button",
                                                              icon: "pi pi-ellipsis-v",
                                                              onClick: _withModifiers(($event: any) => (_ctx.actionButtonToggle($event,index)), ["stop"]),
                                                              style: {"background-color":"white","color":"black","border":"white"}
                                                            }, null, 8, ["onClick"]),
                                                            _createVNode(_component_Menu, {
                                                              ref_for: true,
                                                              ref: 'menu' + index,
                                                              model: _ctx.actionButtonItems(row),
                                                              popup: true,
                                                              class: "menuWidth",
                                                              appendTo: "body"
                                                            }, null, 8, ["model"])
                                                          ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                            _createElementVNode("div", {
                                                              class: "table-ellipsis",
                                                              onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                                            }, _toDisplayString(row[presentColumn]), 41, _hoisted_51)
                                                          ]))
                            ], 46, _hoisted_26))
                          }), 128))
                        ]))
                      }), 128))
                    ]))
            ], 4)
          ])
        ]),
        _createVNode(_component_pagination, {
          dynamicPagination: _ctx.dynamicPagination,
          onCurrentPageUpdate: _ctx.paginationUpdations,
          sortedData: _ctx.sortedData,
          pageData: _ctx.pageData
        }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData", "pageData"])
      ], 2)
    ])
  ]))
}